import { Trans } from "@lingui/macro";

import { useLocalize } from "../../content/useLocalize";
import type { Tool } from "../../types";
import { Button } from "../common/Button";
import { Modal } from "../common/Modal";
import { formatMoney } from "../common/format";
import styles from "./ToolPurchaseModal.module.css";

export interface ToolPurchaseModalProps {
  tool: Tool;
  money: number;
  onConfirm: () => void;
  onClose: () => void;
}

export function ToolPurchaseModal({ tool, money, onConfirm, onClose }: ToolPurchaseModalProps): JSX.Element {
  const t = useLocalize();
  return (
    <Modal
      title={t(tool.name)}
      onClose={onClose}
      actions={
        <>
          <Button variant="ghost" size="small" onClick={onClose}>
            <Trans>Отмена</Trans>
          </Button>
          <Button variant="primary" size="small" onClick={onConfirm}>
            <Trans>Купить</Trans>
          </Button>
        </>
      }
    >
      <p className={styles.effect}>{t(tool.effect)}</p>
      <div className={styles.rows}>
        <div className={styles.row}>
          <span><Trans>Цена</Trans></span>
          <span className="mono">{formatMoney(tool.cost)}</span>
        </div>
        <div className={styles.row}>
          <span><Trans>Баланс</Trans></span>
          <span className="mono">{formatMoney(money)}</span>
        </div>
        <div className={styles.row}>
          <span><Trans>Останется</Trans></span>
          <span className="mono">{formatMoney(money - tool.cost)}</span>
        </div>
      </div>
    </Modal>
  );
}
